import React from 'react';
import {
  FiActivity,
  FiAlertCircle,
  FiAlertTriangle,
  FiArrowLeft,
  FiArrowRight,
  FiBarChart2,
  FiBell,
  FiBriefcase,
  FiCalendar,
  FiCheck,
  FiCheckCircle,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiCircle,
  FiClipboard,
  FiClock,
  FiCopy,
  FiDatabase,
  FiDollarSign,
  FiDownload,
  FiEdit,
  FiExternalLink,
  FiEye,
  FiEyeOff,
  FiFileText,
  FiFilter,
  FiFlag,
  FiGlobe,
  FiHome,
  FiKey,
  FiLoader,
  FiMail,
  FiMapPin,
  FiMenu,
  FiMessageSquare,
  FiMic,
  FiMinus,
  FiMoreVertical,
  FiMousePointer,
  FiPause,
  FiPhone,
  FiPhoneCall,
  FiPhoneIncoming,
  FiPlay,
  FiPlus,
  FiRefreshCw,
  FiSave,
  FiSearch,
  FiSend,
  FiSettings,
  FiShare2,
  FiShield,
  FiSkipBack,
  FiSkipForward,
  FiStar,
  FiTag,
  FiTarget,
  FiThumbsDown,
  FiThumbsUp,
  FiTrash2,
  FiTrendingDown,
  FiTrendingUp,
  FiUpload,
  FiUser,
  FiUsers,
  FiVolume2,
  FiWifi,
  FiWifiOff,
  FiX,
  FiXCircle
} from 'react-icons/fi';

const ICON_COMPONENTS = {
  FiActivity,
  FiAlertCircle,
  FiAlertTriangle,
  FiArrowLeft,
  FiArrowRight,
  FiBarChart2,
  FiBell,
  FiBriefcase,
  FiCalendar,
  FiCheck,
  FiCheckCircle,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiCircle,
  FiClipboard,
  FiClock,
  FiCopy,
  FiDatabase,
  FiDollarSign,
  FiDownload,
  FiEdit,
  FiExternalLink,
  FiEye,
  FiEyeOff,
  FiFileText,
  FiFilter,
  FiFlag,
  FiGlobe,
  FiHome,
  FiKey,
  FiLoader,
  FiMail,
  FiMapPin,
  FiMenu,
  FiMessageSquare,
  FiMic,
  FiMinus,
  FiMoreVertical,
  FiMousePointer,
  FiPause,
  FiPhone,
  FiPhoneCall,
  FiPhoneIncoming,
  FiPlay,
  FiPlus,
  FiRefreshCw,
  FiSave,
  FiSearch,
  FiSend,
  FiSettings,
  FiShare2,
  FiShield,
  FiSkipBack,
  FiSkipForward,
  FiStar,
  FiTag,
  FiTarget,
  FiThumbsDown,
  FiThumbsUp,
  FiTrash2,
  FiTrendingDown,
  FiTrendingUp,
  FiUpload,
  FiUser,
  FiUsers,
  FiVolume2,
  FiWifi,
  FiWifiOff,
  FiX,
  FiXCircle
};

const ICON_MAP = Object.entries(ICON_COMPONENTS).reduce((acc, [key, component]) => {
  acc[key] = component;
  if (key.startsWith('Fi')) {
    acc[key.slice(2)] = component;
  }
  return acc;
}, {});

const SafeIcon = ({ icon, name, ...props }) => {
  const IconComponent = icon || (name ? ICON_MAP[name] || ICON_MAP[`Fi${name}`] : null);

  return IconComponent ? (
    React.createElement(IconComponent, props)
  ) : (
    React.createElement(ICON_COMPONENTS.FiAlertTriangle, props)
  );
};

export default SafeIcon;
